export { default } from './CurrierPage';
